import { PatientProfile, ProfileStatus } from '@/lib/apis/types'
import {
  PersonalDetailsFormState,
  PersonalDetailsFormValidator,
  VerificationOutcome,
} from '@/shared/request/PersonalDetailsFormStage'

export function computeProfileFormState(
  profile: PatientProfile | null,
  profileStatus: ProfileStatus | null,
): PersonalDetailsFormState {
  return {
    values: PersonalDetailsFormValidator.cast(
      profile
        ? { ...profile, acceptTnc: profileStatus?.completed === true }
        : {},
    ),
    verification: {
      verifiedEmail:
        profile?.email && profileStatus?.emailVerified === true
          ? profile.email
          : undefined,
      mobileVerificationResult:
        profile?.mobile && profileStatus?.mobileVerified
          ? {
              address: profile.mobile,
              alreadyVerified: true,
            }
          : undefined,
    } as VerificationOutcome,
  }
}
